// Store de tema (claro/oscuro) con Zustand
import { create } from 'zustand'

// Detectar preferencia del sistema operativo
const getSystemTheme = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
  }
  return 'dark'
}

// Obtener tema guardado o usar preferencia del sistema
const getInitialTheme = () => {
  const saved = localStorage.getItem('subigol_theme')
  return saved || getSystemTheme()
}

const useThemeStore = create((set, get) => ({
  theme: getInitialTheme(),

  // Alternar entre claro y oscuro
  toggleTheme: () => {
    const newTheme = get().theme === 'dark' ? 'light' : 'dark'
    localStorage.setItem('subigol_theme', newTheme)
    // Aplicar clase al documento
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(newTheme)
    set({ theme: newTheme })
  },

  // Establecer tema específico
  setTheme: (theme) => {
    localStorage.setItem('subigol_theme', theme)
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(theme)
    set({ theme })
  },

  // Inicializar tema al cargar la aplicación
  initTheme: () => {
    const theme = get().theme
    document.documentElement.classList.add(theme)
  },
}))

export default useThemeStore
